// This is a flags type enum so each enum value needs to be the next power of 2 (e.g. 4, 8, 16...)
export enum GroupType {
	None = 0,
	TheirGroupOnly = 1,
	TheirGroupAndAllBelow = 2,
	TheirRollupsOnly = 4,
	TheirRollupsAndAllBelow = 8,
}
